import { t } from "i18next"
import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { useHistory, useLocation } from "react-router-dom"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { initialFilterTable } from "../../../../../component/atoms/Tabel/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../config/EndpointCollection.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { KPI_GOAL_SETTING_TAB } from "../../../../../constants/StringConstant.js"
import {
  getKpiGoalThisYearTargetRegional,
  getListTargetSubRegionalByRegionalIdAndYear
} from "../../../../../redux/actions/FieldOfficerAction.jsx"
import { loadUserLogin } from "../../../../service/userManagementAction.js"

export function useDetailKpiGoalSettingPage() {
  const { General, FieldOfficer } = useSelector((state) => state)
  const { year, regional } = useParams()
  const subHeader = useSubheader()
  const location = useLocation()
  const dispatch = useDispatch()
  const user = loadUserLogin()
  const regionalId = regional || user?.regional_id
  const history = useHistory()
  const privileges = user?.privilege || []

  const searchParams = new URLSearchParams(location?.search)
  const selectedMonth = searchParams.get("month") != null && searchParams.get("month") !== ""
    ? parseInt(searchParams.get("month"))
    : null

  const [currentParam, setCurrentParam] = useState({
    ...initialFilterTable,
    month: selectedMonth,
  })

  const handleMonthChange = (month) => {
    let urlParam = ""
    if (month != null) {
      const next = { ...currentParam, month }
      urlParam = getUrlParsingPageFilter(next)
      setCurrentParam(next)
    } else {
      const { ...rest } = currentParam
      urlParam = getUrlParsingPageFilter(rest)
      setCurrentParam(rest)
    }

    history.push({ pathname: location.pathname, search: urlParam })
  }

  useEffect(() => {
    if (regionalId && year) {
      dispatch(getKpiGoalThisYearTargetRegional(year, regionalId))
    }
  }, [regionalId, year])

  function fetchData(param = "") {
    dispatch(getListTargetSubRegionalByRegionalIdAndYear(regionalId, year, param))
  }

  useEffect(() => {
    const urlParam = getUrlParsingPageFilter(currentParam)
    history.replace({ pathname: location.pathname, search: urlParam })
  }, [currentParam])

  useEffect(() => {
    fetchData(location?.search)
  }, [location?.search])

  useEffect(() => {
    subHeader.setButton(null)
    const dataBreadcrumb = [
      {
        pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.THIS_YEAR, year),
        title: t("label_kpi_goal_setting")
      },
      {
        pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING(regionalId, KPI_GOAL_SETTING_TAB.HISTORY, year),
        title: t("label_history_kpi_goal_setting")
      },
      {
        title: t("label_detail_history_kpi_goal_setting", { year: year })
      }
    ]
    if (!user?.regional_id) {
      dataBreadcrumb.unshift({
        pathname: RoutesConstants.FIELD_OFFICER.KPI_GOAL_SETTING_INDEX(),
        title: t("sub_header_all_regional")
      })
    }
    subHeader.setBreadcrumbs(dataBreadcrumb)
  }, [])

  const changePage = useCallback(
    (param) => {
      let urlParam = getUrlParsingPageFilter({ ...currentParam, ...param })
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, currentParam]
  )

  return { year, General, FieldOfficer, currentParam, changePage, regionalId, selectedMonth, handleMonthChange, privileges }
}
